unit Search.STSupplier;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, VCL.TMSFNCTypes, VCL.TMSFNCUtils,
  VCL.TMSFNCGraphics, VCL.TMSFNCGraphicsTypes, System.Rtti,
  VCL.TMSFNCDataGridCell, VCL.TMSFNCDataGridData, VCL.TMSFNCDataGridBase,
  VCL.TMSFNCDataGridCore, VCL.TMSFNCDataGridRenderer, VCL.TMSFNCCustomComponent,
  VCL.TMSFNCDataGridDatabaseAdapter, VCL.TMSFNCCustomControl,
  VCL.TMSFNCDataGrid, Vcl.StdCtrls, WEBLib.StdCtrls, WEBLib.Buttons,
  Vcl.Controls, WEBLib.ExtCtrls, Data.DB, WEBLib.DB, XData.Web.JsonDataset,
  XData.Web.Dataset, XData.Web.Client;

type
  TfrmSearchSTSupplier = class(TWebForm)
    wpMain: TWebPanel;
    WebLabel1: TWebLabel;
    WebPanel1: TWebPanel;
    btnBack: TWebSpeedButton;
    btnSelect: TWebSpeedButton;
    weSearch: TWebEdit;
    TMSFNCDataGrid1: TTMSFNCDataGrid;
    dgdbaSearch: TTMSFNCDataGridDatabaseAdapter;
    wcSearch: TXDataWebClient;
    wdsSearch: TXDataWebDataSet;
    dsSearch: TWebDataSource;
    wdsSearchautono: TIntegerField;
    wdsSearchdepotname: TStringField;
    procedure WebFormShow(Sender: TObject);
    procedure TMSFNCDataGrid1CellClick(Sender: TObject; AColumn, ARow: Integer);
    procedure btnSelectClick(Sender: TObject);
    procedure btnBackClick(Sender: TObject);
  private
    { Private declarations }
  public
    { Public declarations }
    iAutoSTDepot : Integer;
    sSTDepotName : String;
  end;

var
  frmSearchSTSupplier: TfrmSearchSTSupplier;

implementation

{$R *.dfm}
uses
  stfmssystem.connection ,  share.common;

procedure TfrmSearchSTSupplier.btnBackClick(Sender: TObject);
begin
  iAutoSTDepot := -1;
  sSTDepotName := '';
end;

procedure TfrmSearchSTSupplier.btnSelectClick(Sender: TObject);
begin
  Close;
end;

procedure TfrmSearchSTSupplier.TMSFNCDataGrid1CellClick(Sender: TObject;
  AColumn, ARow: Integer);
begin
  dgdbaSearch.SetActiveRecord(ARow);
  iAutoSTDepot := dgdbaSearch.FieldAtColumn[0].AsInteger;
  sSTDepotName := dgdbaSearch.FieldAtColumn[1].AsString;
end;

procedure TfrmSearchSTSupplier.WebFormShow(Sender: TObject);
 procedure OnSuccess(Response : TXDataClientResponse);
    begin
      wdsSearch.Close;
      wdsSearch.SetJsonData(TJSArray(TJSObject(Response.Result)['value']));
      wdsSearch.Open;
    end;

begin
  wcSearch.RawInvoke('IstfmsdieselService.Get_SupplierDepots_View',['*'],@OnSuccess);
end;

end.